import React, { useRef, useEffect, useState } from "react";
import "../styles/styles.css";

const VideoPlayer = ({ videoUrl, user }) => {
  const videoRef = useRef(null);
  const [showOverlay, setShowOverlay] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleTimeUpdate = () => {
      if (!user && video.currentTime >= 60) {
        video.pause();
        setShowOverlay(true);
      }
    };

    if (!user) {
      video.addEventListener("timeupdate", handleTimeUpdate);
    }

    return () => {
      if (video) {
        video.removeEventListener("timeupdate", handleTimeUpdate);
      }
    };
  }, [user]);

  const handleRegister = () => {
    window.location.href = "/register";
  };

  return (
    <div className="video-player-container">
      <video controls className="video-player" ref={videoRef}>
        <source src={videoUrl} type="video/mp4" />
        Tu navegador no soporta el elemento de video.
      </video>
      {showOverlay && (
        <div className="video-overlay">
          <p>Regístrate para ver el resto del vídeo</p>
          <button className="btn-primary" onClick={handleRegister}>
            Registrarse
          </button>
        </div>
      )}
    </div>
  );
};

export default VideoPlayer;
